/**
 * NZSC-3086 — 셜록 구독제 (NZSC-3047 + 부속 NZSC-3051/3078/3082/3083) 진입점 2단계 토글.
 *
 * mobileBottomBarHelpers 의 fnIsCreditDefaultVisible 와 동일 패턴.
 * 진입점 4곳 게이팅 (헤더 CTA / 사이드바 신 카드 / SubscriptionInfo 라우트 / 모바일 칩-탭).
 *
 * 우선순위:
 *   FEATURE_FLAG_ENABLED === true                                   → 전체 오픈 (테스터 플래그 무시)
 *   INTERNAL_TESTER_ENABLED === true && isInternalTester === true    → 내부 테스터 한정 노출
 *   그 외                                                              → 미노출 (옛 UI 유지)
 *
 * 풀 오픈 시점:
 *   1) FEATURE_FLAG_ENABLED = true 로 변경 (또는 본 헬퍼 호출처 자체 제거)
 *   2) INTERNAL_TESTER_ENABLED 는 정리 차원에서 함께 false 로 되돌리거나 헬퍼 제거
 */

/**
 * 단위 테스트용 팩토리. 운영 코드는 아래 모듈 상수 바인딩한 fnIsSherlockSubscriptionEnabled 를 사용.
 *
 * @param {boolean} featureFlagEnabled       전체 오픈 플래그
 * @param {boolean} internalTesterEnabled    테스터 한정 노출 플래그
 * @returns {(isInternalTester: boolean) => boolean}
 */
export function fnCreateSherlockSubscriptionAccessChecker(
  featureFlagEnabled,
  internalTesterEnabled,
) {
  return function fnIsSherlockSubscriptionEnabled(isInternalTester) {
    if (featureFlagEnabled === true) return true;
    if (internalTesterEnabled && isInternalTester === true) return true;
    return false;
  };
}

/**
 * 운영 상수 — 배포 단계별 토글:
 *   1차 prod 배포: FEATURE_FLAG_ENABLED=false + INTERNAL_TESTER_ENABLED=true → 내부 테스터만 노출
 *   풀 오픈:       FEATURE_FLAG_ENABLED=true (또는 호출처 제거)
 *
 * env 의존성 제거 — FE 재배포로 토글 (Vercel/Vue 빌드 시점 상수).
 */
const FEATURE_FLAG_ENABLED = true;
const INTERNAL_TESTER_ENABLED = true;

export const fnIsSherlockSubscriptionEnabled = fnCreateSherlockSubscriptionAccessChecker(
  FEATURE_FLAG_ENABLED,
  INTERNAL_TESTER_ENABLED,
);
